export const removeEmptyNewlines = (input) => {
    return input.replace(/^\s*[\r\n]/gm, "");
};
//# sourceMappingURL=removeEmptyNewlines.js.map